
export const roiChartConfig: ROIConfig = {
  title: "Return On Investment",
  roiValue: "283% ROI",
  monthlyChange: "+24% January",
  activeColor: "#4680ff",
  inactiveColor: "#e8edf3",
  chartData: [
    { month: "JAN", value: 45 },
    { month: "FEB", value: 85, active: true },
    { month: "MAR", value: 55 },
    { month: "APR", value: 60 },
    { month: "MAY", value: 50 },
    { month: "JUN", value: 65 },
  ],
};
